import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { ColorTokens, DividerSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { appendURlWithParam, isMobile, setAppHeader } from '../../configs/utils';
import { ACTION } from "../partnerWeb_Dashboard/types";
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { SideBarBuilderDS } from "../sideNavBar";
import { goToRegister, onChangeTab, onShareLinkRef, openMenu } from "./action";
import { BottomNavBuilderDS } from "../bottomNav";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress } from "../partnerWeb_Dashboard/actions";
import { partnerApi, StoreKey } from "../../configs/api";
import { getAppHeader } from "../../configs/config";
import { checkIfPartnerDetailsAdded, navigateByUrl, ShowNewRmContactButton } from "../partnerWeb_Dashboard/utils";
import { AppLink } from "../../configs/constants";
import { isSDKInvestwell, showShareLink } from "../../configs/uri-config-utils";
const _isMobile = isMobile();
export const template = async (partnerAccountId, user, isPartnerPlatform, platform, showNewRmContactButton, rmData, isFromMobile) => ({
    layout: {
        id: ROUTE.PARTNER_CHECK_LIMIT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            { id: 'partnerCheckLimitMainStack', type: WIDGET.STACK },
            isFromMobile ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ]
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_CHECK_LIMIT,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...await PartnerHeader(ROUTE.PARTNER_CHECK_LIMIT, undefined, user),
        ...await SideBarBuilderDS(ROUTE.PARTNER_CHECK_LIMIT),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_CHECK_LIMIT),
        partnerCheckLimitMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            padding: {
                top: SizeTypeTokens.XXXL,
                left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                { id: 'partnerCheckLimitMainStack1', type: WIDGET.STACK },
            ]
        },
        partnerCheckLimitMainStack1: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            maxWidth: 650,
            // padding: {
            //     top: SizeTypeTokens.XXXL,
            //     left: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            //     right: _isMobile ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            // },
            widgetItems: [
                { id: 'partnerCheckLimitWebView', type: WIDGET.WEB_VIEW },
                { id: 'partnerCheckLimitMainStack1Space1', type: WIDGET.SPACE },
                { id: 'partnerCheckLimitMainStack1Divider', type: WIDGET.DIVIDER },
                { id: 'partnerCheckLimitMainStack1Space1', type: WIDGET.SPACE },
                { id: 'partnerCheckLimitMainStack1Stack1', type: WIDGET.STACK },
                { id: 'partnerCheckLimitMainStackSpaceBottom', type: WIDGET.SPACE },
                { id: 'partnerCheckLimitMainStackSpaceBottom1', type: WIDGET.SPACE }
            ]
        },
        partnerCheckLimitMainStack1Divider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        partnerCheckLimitMainStack1Stack1: {
            type: _isMobile ? StackType.column : StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                showShareLink(user) ? { id: 'partnerCheckLimitMainStack1Stack1Item1', type: WIDGET.PARTNER_CHECK_LIMIT_DETAIL_CARD } : {},
                showShareLink(user) ? { id: 'partnerCheckLimitMainStack1Stack1Space1', type: WIDGET.SPACE } : {},
                { id: 'partnerCheckLimitMainStack1Stack1Item2', type: WIDGET.PARTNER_CHECK_LIMIT_DETAIL_CARD },
            ]
        },
        partnerCheckLimitMainStack1Stack1Space1: {
            size: SizeTypeTokens.XXXL
        },
        partnerCheckLimitMainStack1Stack1Item1: {
            icon: {
                name: IconTokens.Share4,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            title: 'Share with your customer',
            subTitle: 'Invite your customers to check their credit limit in just 15s',
            actionItems: [
                {
                    title: 'Share link \u276F',
                    action: {
                        routeId: ROUTE.PARTNER_CHECK_LIMIT,
                        type: ACTION.SHARE_LINK_REF,
                        payload: {}
                    }
                }
            ],
            isMobile: _isMobile
        },
        partnerCheckLimitMainStack1Stack1Item2: {
            icon: {
                name: IconTokens.Meter_1,
                size: _isMobile ? IconSizeTokens.XXXL : IconSizeTokens.XXXXXL
            },
            title: 'Check limit manually',
            subTitle: 'No OTP is required. Check limit based on fund name',
            isMobile: _isMobile,
            showComingSoon: true,
            actionItems: []
        },
        partnerCheckLimitMainStack1Space1: {
            size: SizeTypeTokens.XXXL
        },
        partnerCheckLimitWebView: {
            uri: `${AppLink}${isPartnerPlatform ? `partnerPlatform` : ''}?${isPartnerPlatform ? `platform=${platform}&` : ''}isIframe=true&isCheckLimitMFC=true&partnerAccountId=${partnerAccountId}&source=PARTNER_DASHBOARD&showVoltDefaultHeader=false`,
            isHeightDynamic: true,
            shouldScroll: true,
            iframe: true,
            width: _isMobile ? '100%' : 650,
            eventId: 'getUserData',
            isBordered: true,
            eventAction: {
                routeId: ROUTE.PARTNER_CHECK_LIMIT,
                type: ACTION.GO_TO_REGISTER,
                payload: {}
            }
        },
        partnerCheckLimitMainStackSpaceBottom: {
            size: SizeTypeTokens.Size80
        },
        partnerCheckLimitMainStackSpaceBottom1: {
            size: SizeTypeTokens.Size80
        },
    },
});
export const partnerCheckLimitMF = {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    onLoad: async ({ network, instrumentTrack, asyncStorage, openNewTab, initializeAmplitude, ...props }) => {
        await checkIfPartnerDetailsAdded({ network: network, openNewTab: openNewTab });
        appendURlWithParam('free-eligibility-check');
        await setAppHeader();
        const userData = JSON.parse(await asyncStorage.get('user_context'));
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        let isPartnerPlatform = false;
        let platform = '';
        if (isSDKInvestwell(userData)) {
            isPartnerPlatform = true;
            platform = `${userData?.linkedPlatformAccounts[0]?.platformCode}`;
        }
        const isFromMobile = isMobile();
        if (accessToken) {
            const header = await getAppHeader();
            header['X-AppPlatform'] = 'VOLT_WEB_APP';
            const response = await network.post(partnerApi.userContext, {}, { headers: header }, async () => {
                return;
            }, {
                isPartnerPlatform: true,
            });
            if (response["status"] === 200) {
                const _user = response?.data;
                console.log("_user: ", _user);
                await asyncStorage.remove(StoreKey.EXTERNAL_ROUTE);
                await asyncStorage.set(StoreKey.userContext, JSON.stringify(response?.data));
            }
            else {
                //in case access token expires
                await asyncStorage.set(StoreKey.EXTERNAL_ROUTE, `${ROUTE.PARTNER_CHECK_LIMIT}`);
                return navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            }
        }
        else {
            await asyncStorage.set(StoreKey.EXTERNAL_ROUTE, `${ROUTE.PARTNER_CHECK_LIMIT}`);
            // setTimeout(async ()=> {
            //     await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            // }, 250)
            return await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
        }
        const partnerAccountId = userData?.linkedPartnerAccounts[0]?.accountId;
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const header = await getAppHeader();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        return Promise.resolve(template(partnerAccountId, userData, isPartnerPlatform, platform, showNewRmContactButton, rmData, isFromMobile));
    },
    actions: {
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.GO_TO_REGISTER]: goToRegister,
        [ACTION.SHARE_LINK_REF]: onShareLinkRef,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    }
};
